/* Maison — open pages at the top unless the URL carries an anchor. */
if (!location.hash) { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; window.addEventListener('pageshow', () => { window.scrollTo(0, 0); }); setTimeout(() => { if (!location.hash && scrollY > 0 && !sessionStorage.getItem('maison-user-scrolled')) window.scrollTo(0, 0); }, 300); }
window.addEventListener('scroll', () => sessionStorage.setItem('maison-user-scrolled', '1'), { once: true, passive: true });

/* Maison — compte à rebours réel jusqu'à l'heure limite d'expédition (jours ouvrés), mis à jour chaque seconde. */
(function () {
  function nextCutoff(hour) {
    var d = new Date(); d.setSeconds(0, 0);
    var c = new Date(d); c.setHours(hour, 0, 0, 0);
    if (Date.now() >= c.getTime()) c.setDate(c.getDate() + 1);
    while (c.getDay() === 0 || c.getDay() === 6) c.setDate(c.getDate() + 1);
    return c;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    document.querySelectorAll('[data-maison-timer]').forEach(function (el) {
      var hour = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var target = nextCutoff(hour), ms = target.getTime() - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      var s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var out = el.querySelector('[data-maison-timer-value]'); if (out) out.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
      var dayEl = el.querySelector('[data-maison-timer-day]');
      if (dayEl) { var ship = new Date(target); ship.setDate(ship.getDate() + 1); while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
        var today = new Date(); today.setHours(0,0,0,0); var diff = Math.round((new Date(ship.getFullYear(), ship.getMonth(), ship.getDate()) - today) / 86400000);
        dayEl.textContent = diff === 1 ? 'demain' : ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'][ship.getDay()]; }
      el.hidden = false;
    });
  }
  tick(); setInterval(tick, 1000);
})();

/* Maison — réservation du panier : chrono démarré à l'ajout d'un article, mémorisé dans le navigateur, pas de redémarrage à l'ouverture. */
(function () {
  var KEY = 'maison-reserve';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var el = document.querySelector('[data-maison-reserve]'); if (!el) return;
    var count = parseInt(el.getAttribute('data-count'), 10) || 0, minutes = parseInt(el.getAttribute('data-minutes'), 10) || 5;
    var st = read();
    if (count === 0) { write(null); return; }
    if (!st || count > st.count) { st = { count: count, deadline: Date.now() + minutes * 60000 }; write(st); }
    else if (count !== st.count) { st.count = count; write(st); }
    var ms = st.deadline - Date.now(), out = el.querySelector('[data-maison-reserve-value]'), txt = el.querySelector('[data-maison-reserve-text]');
    if (ms <= 0) { el.classList.add('maison-cart-reserve--expired'); if (txt) txt.textContent = 'Réservation expirée : les articles restent dans votre panier, sous réserve de disponibilité.'; return; }
    el.classList.remove('maison-cart-reserve--expired');
    var s = Math.ceil(ms / 1000); if (out) out.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
  }
  tick(); setInterval(tick, 1000);
})();
